<template>
	<div class="search-provider-view">
        <div class="container-fluid p-0">
            <SearchProvider @startSearch="startSearch" @holdResults="holdResults"  @startLoading="startLoading"/>

            <SearchProviderResults
                v-if="showResults"
                :searchAddress="searchAddress"
                @stopLoading="stopLoading"
            />

            <!-- <div v-if="loading">
                <tile :loading="loading" height="10" width="10"></tile>
            </div> -->
        </div>
	</div>
</template>

<script>
import SearchProvider from '@/components/search_provider/SearchProvider'
import SearchProviderResults from '@/components/search_provider/SearchProviderResults'

export default {
    name: 'SearchProviderView',
    components: {
        SearchProvider,
        SearchProviderResults,
    },

    data() {
        return {
            hResults: null,
            cetinShow: true,
            cetinShowProducts: false,
            loading: false,
            showResults: false,
            searchAddress: null,
        }
    },

    methods: {
        stopLoading () {
            this.showResults = true
        },

        startLoading() {
            this.showResults = false
        },

        holdResults (items, what) {
            if (what) {
                this.hResults = items
            } else {
                this.hResults = null
            }
        },

        startSearch (adresniMisto, what) {
            // this.startLoading()
            // this.showResults = false
            // console.log('SearchProviderView: startSearch', adresniMisto, what)
            if (what) {
                this.searchAddress = adresniMisto
            } else {
                this.searchAddress = null
            }
            this.showResults = true
        },
    }
}
</script>

<style lang="stylus" scoped>

.search-provider-view
    background-color #e0ecff
    min-height 100vh
    max-height 100vh
    overflow-y scroll
</style>



// WEBPACK FOOTER //
// src/views/SearchProviderView.vue